import {
  faCheck,
  faDownload,
  faRefresh,
  faSliders,
  faSort,
  faSortDown,
  faSortUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
} from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap-table-next';
import Pagination from 'react-bootstrap-table2-paginator';
import * as Paginator from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { updateToastInfo } from '../../actions/settings';
import BreadCrumbComponent from './Breadcrumb';
import ExcelDownloadReport from './excel/download';
import DateRangeSelector from './DateRangeSelector';
import DropdownComponent from './Dropdown';
import EmptyTable from './EmptyTableView';
import FileUploadButton from '../common/fileUpload';
import FilterOrders from '../../pages/oms/orders/FIlterOrders';
import { returnOrderStatus } from '../../constants/orderStatus';
import { setPageNumberInStore } from '../../actions/tablePage';
import ExportButton from '../../pages/oms/orders/components/ExportButton';
import UploadFile from '../../pages/oms/products/components/UploadFile';
import InfoModal from '../../pages/oms/inventory/components/InfoModal';
import { getColumnsForExcelUpload } from '../../pages/oms/orders/utils';

export const customTotal = (from, to, size) => (
  <div className="w-100 d-flex justify-content-center">
    Showing {from} to {to} of {size} entries
  </div>
);

export const customSizePerPage = (props) => {
  const { options, currentSizePerPage, onSizePerPageChange } = props;

  const onPageChange = (e) => {
    const page = e.target.value;
    onSizePerPageChange(page);
  };

  return (
    <Row>
      <Col xs="auto">
        <Form.Select
          value={currentSizePerPage}
          onChange={onPageChange}
          className="pe-5"
        >
          {options.map((o) => (
            <option key={o.page} value={o.page}>
              {o.text}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col xs="auto" className="d-flex align-items-center">
        entries per page
      </Col>
    </Row>
  );
};
const OrderListPage = (props) => {
  const {
    pageTitle,
    breadCrumbItems,
    pageSubTitle,
    searchPlaceHolder,
    tableColumns = [],
    tableData = [],
    filterSubmit,
    handleRefresh,
    handleItemBulkUpdate,
    bulkActionOptions,
    enableBulkActions,
    hideBulkActions = false,
    showDateFilters = false,
    filtersValue,
    pageType,
    showFileUploadSection = false,
    onFileUpload,
    sampleFileUrl,
    onRowClick,
    filter = true,
    setQueryParam,
    uploadButtonProps,
    handleBulkUploadSubmit,
    type,
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [bulkActionSelectedOption, setBulkActionSelectedOption] =
    useState(null);

  const [showData, setShowData] = useState(tableData);
  const [uploadedData , setUploadedData] = useState([])
  const [showUploadDataModal , setShowUploadDataModal] = useState(false)
  const handleUploadClicked = (fileData) => {
    setUploadedData(fileData)
    setShowUploadDataModal(true)
  }
  const [openFilter, setOpenFilter] = useState(true);
  useEffect(() => {
    setShowData(tableData);
  }, [tableData]);
  const handleItemUpdate = () => {
    if (bulkActionSelectedOption) {
      handleItemBulkUpdate(bulkActionSelectedOption);
    } else {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('Select an Action'),
          message: t('Please select an action from the dropdown'),
        })
      );
    }
  };
  const totalPages = Math.ceil((showData?.length || 0) / 10);
  const storedPage = useSelector((state) => state?.pageNumber?.[pageType] || 1);
  const [currentPage, setCurrentPage] = useState(
    storedPage > totalPages ? 1 : storedPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (pageType) {
      dispatch(setPageNumberInStore({ id: pageType, page }));
    }
  };

  useEffect(() => {
    setCurrentPage(storedPage > totalPages ? 1 : storedPage);
  }, [storedPage, totalPages]);
  const handleOnFileUpload = (fileContent) => {};

  const handleFilter = () => {
    setOpenFilter(!openFilter);
  };

  const rowStyle = (row, rowIndex) => {
    if (row?.isIBT) {
      return 'table-success';
    }
    if (row?.isHyperLocal) {
      return 'table-warning';
    }
    if(row?.isBiker) {
      return 'table-secondary'
    }
    if (row?.isPorter) {
      return 'table-secondary';
    }
    return '';
  };

  return (
    <>
      <div>
        <ToolkitProvider
          exportCSV
          keyField="id"
          search={true}
          sort
          columns={tableColumns}
          data={showData}
          wrapperClasses="table-responsive"
        >
          {({ baseProps, searchProps, csvProps }) => (
            <Paginator.PaginationProvider
              pagination={Pagination({
                custom: true,
                showTotal: true,
                alwaysShowAllBtns: true,
                totalSize: Object.values(showData)?.length,
                paginationTotalRenderer: customTotal,
                sizePerPageRenderer: customSizePerPage,
                onPageChange: handlePageChange,
                page: currentPage,
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <>
                  <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                      <BreadCrumbComponent items={breadCrumbItems} />
                      <h4>{pageTitle}</h4>
                      <p className="mb-0">{pageSubTitle}</p>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                      <ButtonGroup className="gap-2">
                        {/* {pageTitle ===
                          returnOrderStatus.REFUND_INITIATED + ' Orders' && ( */}
                        {uploadButtonProps && (
                          <UploadFile
                            uploadedData={handleUploadClicked}
                            sampleFileUrl={uploadButtonProps?.url}
                            buttonText={uploadButtonProps?.text}
                            buttonSize="md"
                          />
                        )}
                        {/* )} */}
                        <Button
                          variant={openFilter ? 'primary' : 'white'}
                          onClick={handleFilter}
                          style={{
                            width: '150px',
                            height: '38px',
                            borderRadius: 0,
                          }}
                          size="sm"
                        >
                          <FontAwesomeIcon icon={faSliders} />
                          &nbsp;&nbsp;{t('Filter')}
                        </Button>

                        <Button
                          variant="white"
                          onClick={handleRefresh}
                          style={{
                            width: '150px',
                            height: '38px',
                            borderRadius: 0,
                          }}
                          size="sm"
                        >
                          <FontAwesomeIcon icon={faRefresh} />
                          &nbsp;&nbsp;{t('Refresh')}
                        </Button>

                        <ExportButton
                          data={tableData}
                          columns={[
                            {
                              field: 'Order Date ',
                              key: 'orderDate',
                            },
                            {
                              field: 'Order Time',
                              key: 'orderTime',
                            },
                            { field: 'Order Number', key: 'orderNo' },
                            { field: 'Item Line No', key: 'itemLineNo' },
                            { field: 'CustomerId', key: 'customerId' },
                            { field: 'Internal Status', key: 'status' },
                            { field: 'Customer Status', key: 'orderStatus' },
                            { field: 'Customer Name', key: 'customerName' },
                            { field: 'Mobile Number', key: 'mobileNumber' },
                            { field: 'Email', key: 'email' },
                            {
                              field: 'Billing Address Line 1',
                              key: 'billingAddress1',
                            },
                            {
                              field: 'Billing Address Line 2',
                              key: 'billingAddress2',
                            },
                            { field: 'Billing City', key: 'billingCity' },
                            { field: 'Billing Pincode', key: 'billingPincode' },
                            { field: 'Billing State', key: 'billingState' },
                            {
                              field: 'Shipping Address Line 1',
                              key: 'shippingAddress1',
                            },
                            {
                              field: 'Shipping Address Line 2',
                              key: 'shippingAddress2',
                            },
                            { field: 'Shipping City', key: 'shippingCity' },
                            {
                              field: 'Shipping Pincode',
                              key: 'shippingPincode',
                            },
                            { field: 'Shipping State', key: 'shippingState' },
                            { field: 'VAN No', key: 'vanNo' },
                            { field: 'Product Title', key: 'productTitle' },
                            { field: 'Category', key: 'category' },
                            { field: 'Sub Category', key: 'subCategory' },
                            { field: 'l1', key: 'l1' },
                            { field: 'l2', key: 'l2' },
                            { field: 'l3', key: 'l3' },
                            { field: 'l4', key: 'l4' },
                            { field: 'Brand', key: 'brand' },
                            { field: 'Quantity', key: 'quantity' },
                            { field: 'VSPrice', key: 'vsPrice' },
                            { field: 'Price', key: 'billingAmount' },
                            { field: 'MRP', key: 'mrp' },
                            { field: 'Order Amount', key: 'orderAmount' },
                            { field: 'Invoice No', key: 'invoiceNo' },
                            { field: 'Store Name', key: 'storeCode' },
                            { field: 'Region', key: 'zone' },
                            { field: 'GSTIN', key: 'gstin' },
                            { field: 'Ewaybill No', key: 'ewayBillNo' },
                            { field: 'Approval Code', key: 'approvalCode' },
                            { field: 'Card No', key: 'cardNo' },
                            { field: 'Product Type', key: 'size' },
                            { field: 'Transaction ID', key: 'paymentType' },
                            { field: 'Payment GateWay', key: 'paymentGateway' },
                            { field: 'Payment Status', key: 'paymentStatus' },
                            { field: 'GST', key: 'igst' },
                            {
                              field: 'Expected Delivery Date',
                              key: 'expectedDeliveryDate',
                            },
                            {
                              field: 'Delivered Date',
                              key: 'deliveredDate',
                            },
                            { field: 'awbNumber', key: 'awbNumber' },
                            { field: 'Bank Name', key: 'bankName' },
                            { field: 'HSN Number', key: 'hsn_number' },
                            { field: 'CashifyQuoteId', key: 'cashifyQuoteId' },
                            { field: 'serviceNumber', key: 'serviceNumber' },
                            {
                              field: 'oldDeviceStatus',
                              key: 'oldDeviceStatus',
                            },
                            {
                              filed: 'IMEI Transcation Id',
                              key: 'cashifyTransactionId',
                            },
                          ]}
                          fileName={'orderData'}
                        />
                      </ButtonGroup>
                    </div>
                  </div>
                  {filter && (
                    <FilterOrders
                      data={tableData}
                      setData={setShowData}
                      openFilter={openFilter}
                      filtersToShow={
                        type == 'Cashify'
                          ? [
                              'vanNo',
                              'orderNo',
                              'startDate',
                              'endDate',
                              'pgRefNo',
                              'cashifyQuoteId',
                              'serialNo',
                            ]
                          : [
                              'vanNo',
                              'orderNo',
                              'storeName',
                              'startDate',
                              'endDate',
                              'region',
                              'productType',
                              'shippingCity',
                            ]
                      }
                      pageType={pageType}
                      setQueryParam={setQueryParam}
                    />
                  )}
                  {showDateFilters && (
                    <div className="table-settings mt-2 mb-2">
                      <Row className="justify-content-start">
                        <Col xs={12} md={6}>
                          <DateRangeSelector
                            onSubmit={filterSubmit}
                            filtersValue={filtersValue}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                  {showFileUploadSection && (
                    <Row className="d-flex justify-content-end">
                      <Col sm={6} className="d-flex justify-content-end">
                        {sampleFileUrl && (
                          <>
                            <Button
                              onClick={() => {
                                window.open(sampleFileUrl, '_blank');
                                dispatch(
                                  updateToastInfo({
                                    show: true,
                                    type: 'success',
                                    title: 'Sample File is downloaded',
                                    message:
                                      'Use this file to remove the data and add your own',
                                  })
                                );
                              }}
                              variant="primary-outline"
                            >
                              <FontAwesomeIcon icon={faDownload} />
                              &nbsp;&nbsp;Download Sample
                            </Button>
                            &nbsp;&nbsp;&nbsp;
                          </>
                        )}
                        <FileUploadButton
                          onFileUpload={handleOnFileUpload}
                          buttonText={'Upload Loader Sheet'}
                        />
                      </Col>
                    </Row>
                  )}
                  <Card>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row className="d-flex justify-content-between">
                          <Col xs={6} md={5} className="d-flex py-1">
                            {!hideBulkActions && (
                              <>
                                <Form.Group
                                  id="substatus"
                                  className="d-flex align-items-center flex-column"
                                >
                                  <DropdownComponent
                                    onChange={(option) => {
                                      setBulkActionSelectedOption(option.value);
                                    }}
                                    width={300}
                                    disabled={!enableBulkActions}
                                    options={bulkActionOptions}
                                    placeholder={t('Select Action')}
                                  />
                                </Form.Group>
                                <Button
                                  style={{
                                    height: 37,
                                  }}
                                  size="sm"
                                  onClick={handleItemUpdate}
                                  disabled={!enableBulkActions}
                                  className="ms-3 btn btn-secondary"
                                  variant="secondary"
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                  &nbsp;&nbsp;{t('Update')}
                                </Button>
                              </>
                            )}
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            className="d-flex justify-content-md-end py-1"
                          >
                            <Search.SearchBar
                              {...searchProps}
                              placeholder={
                                searchPlaceHolder ||
                                t('Search any value in table here')
                              }
                              onSearch={(value) => {
                                setCurrentPage(1);
                                searchProps.onSearch(value);
                              }}
                            />
                            <Search.ClearSearchButton {...searchProps} />
                          </Col>
                        </Row>
                      </Card.Header>

                      <Table
                        {...(onRowClick && {
                          rowEvents: {
                            onClick: (e, row, index) => {
                              onRowClick(row?.objectId);
                            },
                          },
                        })}
                        noDataIndication={<EmptyTable />}
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        classes="table-flush dataTable-table"
                        sort={{
                          sortCaret: (order, column) => {
                            if (!order)
                              return (
                                <span>
                                  &nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faSort} />
                                </span>
                              );
                            else if (order === 'asc')
                              return (
                                <span>
                                  &nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faSortUp} />
                                </span>
                              );
                            else if (order === 'desc')
                              return (
                                <span>
                                  &nbsp;&nbsp;
                                  <FontAwesomeIcon icon={faSortDown} />
                                </span>
                              );
                            return null;
                          },
                        }}
                        rowClasses={rowStyle} // Updated rowClasses prop here
                      />

                      <Card.Footer>
                        <Row>
                          <Col xs={12} md={4} className="py-1">
                            <Paginator.SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            className="d-flex align-items-center py-1"
                          >
                            <Paginator.PaginationTotalStandalone
                              {...paginationProps}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                          >
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                </>
              )}
            </Paginator.PaginationProvider>
          )}
        </ToolkitProvider>
      </div>

      <InfoModal
        showModal={showUploadDataModal}
        closeModal={() => {
          setShowUploadDataModal(false);
        }}
        modalTitile={uploadButtonProps?.infoModalTitle}
        data={uploadedData}
        columns={getColumnsForExcelUpload(uploadedData)}
        size={'xl'}
        showSubmit={true}
        handleSubmit={handleBulkUploadSubmit}
      />
    </>
  );
};
export default OrderListPage;
